import { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBusinessTypes } from '../redux/actions/company';

const BusinessTypeContext = createContext({
   businessTypes: null,
});

export const useBusinessType = () => useContext(BusinessTypeContext);

export const BusinessTypeProvider = ({ children }) => {
   const businessTypes = useSelector((state) => state?.company?.businessTypes);
   localStorage.setItem('businessTypes', businessTypes?.businessType);
   const dispatch = useDispatch();

   useEffect(() => {
      dispatch(getBusinessTypes());
   }, [dispatch]);

   return <BusinessTypeContext.Provider value={{ businessTypes }}>{children}</BusinessTypeContext.Provider>;
};
